<template>
  <div
    class="offer-card"
    @click="$router.push({ path: '/jobs/offer/' + offer.id + '/' + generateSlug})"
  >
    <div class="row">
      <div class="col-12 col-md-2 mb-2">
        <img
          v-if="!offer.companyHideName && offer.user && offer.user.company && offer.user.company.avatar"
          class="company-logo"
          :src="basepath + 'uploads/company_logos/' + offer.user.company.avatar.filename"
        >
        <img
          v-else
          class="company-logo"
          :src="basepath + 'uploads/company_logos/no_logo.png'"
        >
      </div>
      <div class="col-12 col-md-10">
        <h4 class="--bold --gray">
          {{ offer.titleTitle }}
        </h4>
        <div>
          <h4
            v-if="offer.companyHideName === 0 && offer.user && offer.user.company && offer.user.company.title"
            class="--green --bold --smaller --hover"
            @click.stop="$router.push({ path: '/jobs/company/' + offer.user.company.id + '/' + generateCompanySlug })"
          >
            {{ offer.user.company.title }}
          </h4>
          <h4
            v-if="offer.companyHideName === 1"
            class="--gray --smaller"
          >
            {{ $t('pages.public-offers.card.no-company-name') }}
          </h4>
        </div>
        <div class="location">
          <span>{{ offer.locationProvince }} | {{ offer.created_at }}</span>
          <span
            v-if="isNew"
            class="new-offer"
          >{{ $t('pages.public-offers.card.new') }}</span>
        </div>
        <p class="description break-words">
          {{ shortDescription }}
        </p>
        <div class="details">
          {{ $t('pages.public-offers.card.contract.contract') }} <span style="text-transform: lowercase">{{ $t(`data.contractTypes.${offer.contractType}`, offer.contractType) }}</span>
          <span
            style="color: #666"
            class="mx-2"
          >  |  </span>
          {{ $t('pages.public-offers.card.workday.workday') }} <span style="text-transform: lowercase">{{ $t(`data.contractWorkdays.${offer.contractWorkday}`, offer.contractWorkday) }}</span>
          <span
            style="color: #666"
            class="mx-2"
          >  |  </span>
          <!-- Salary -->
          <span v-if="offer.salaryShowAs === 'from-to'">
            {{ offer.salaryMinimum }} - {{ offer.salaryMaximum }} {{ $t(`data.salaryTypes.${offer.salaryType}`, offer.salaryType) }}
          </span>
          <span v-if="offer.salaryShowAs === 'more-than'">
            {{ $t('pages.public-offers.card.salary.more-than') }} {{ offer.salaryMaximum }} {{ $t(`data.salaryTypes.${offer.salaryType}`, offer.salaryType) }}
          </span>
          <span v-if="offer.salaryShowAs === 'dont-show'">
            {{ $t('pages.public-offers.card.salary.no-salary') }}
          </span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    offer: {
      type: Object,
      default: null
    }
  },
  computed: {
    shortDescription() {
      return this.offer.titleDescription.substring(0, 148) + "...";
    },
    generateSlug() {
      let slug = this.offer.titleTitle.replace(/[^A-Z0-9]+/ig, "-").toLowerCase() +
        '/' + this.offer.locationProvince.replace(/[^A-Z0-9]+/ig, "-").toLowerCase();
      return slug;
    },
    generateCompanySlug() {
      let slug = this.offer.user.company.title.replace(/[^A-Z0-9]+/ig, "-").toLowerCase();
      return slug;
    },
    isNew() {
      let OneDay = new Date().getTime() - (1 * 24 * 60 * 60 * 1000);
      let offerDate = new Date(this.offer.created_at);
        if (OneDay < offerDate) {
          return true;
        } else {
          return false;
        }
    },
    basepath() {
      return process.env.VUE_APP_API_URL + process.env.VUE_APP_API_PUBLIC_PATH;
    }
  }
}
</script>


<style lang="scss" scoped>
  .offer-card {
    background: #fff;
    border-radius: 8px;
    padding: 20px;
    margin-bottom: 15px;
    transition: 0.3s ease;
    cursor: pointer;

    &:hover {
      box-shadow: 0 4px 4px 0 rgba(0,0,0,0.04), 0 1px 16px 0 rgba(0,0,0,0.16), 0 2px 4px 0 rgba(0,0,0,0.08);
      background-color: #f6fafc;
    }
  }

  .company-logo {
    width: 100px;
    height: 100px;
    border-radius: 5px;
    border: 1px solid #efefef;
  }

  .location {
    font-size: 0.8rem;
    margin-top: 0.5rem;
    margin-bottom: 0.5rem;
  }

  .description {
    font-size: 0.9rem;
    color: #666;
  }

  .details {
    font-size: 0.9rem;
  }

  .new-offer {
    margin-left: 0.5rem;
    background: #00a550;
    color: white;
    font-size: 0.75rem;
    padding: 2px 3px;
    border-radius: 3px;
  }
</style>
